import React from "react";
import Header from "./header";


import Footer from "./footer";



function Home () {
    return(
        <div className="container">
            <Header/>
            
           
           <Footer/> 
        </div>
    )
}

export default Home;